"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Types = _interopRequireDefault(require("../../types/Types"));

var _ActionCreators = _interopRequireDefault(require("../../change/ActionCreators"));

var _prepUpdater = _interopRequireDefault(require("../../parcelData/prepUpdater"));

var _default = function _default(_this) {
  return {
    set: function set(key, value) {
      (0, _Types.default)("set()", "key", "keyIndex")(key);

      _this.get(key).set(value);
    },
    setIn: function setIn(keyPath, value) {
      (0, _Types.default)("setIn()", "keyPath", "keyIndexPath")(keyPath);

      _this.getIn(keyPath).set(value);
    },
    delete: function _delete(key) {
      (0, _Types.default)("delete()", "key", "keyIndex")(key);

      _this.get(key).delete();
    },
    deleteIn: function deleteIn(keyPath) {
      (0, _Types.default)("deleteIn()", "keyPath", "keyIndexPath")(keyPath);

      _this.getIn(keyPath).delete();
    },
    update: function update(key, updater) {
      (0, _Types.default)("update()", "key", "keyIndex")(key);
      (0, _Types.default)("update()", "updater", "function")(updater);

      _this.get(key).update(updater);
    },
    updateIn: function updateIn(keyPath, updater) {
      (0, _Types.default)("updateIn()", "keyPath", "keyIndexPath")(keyPath);
      (0, _Types.default)("updateIn()", "updater", "function")(updater);

      _this.getIn(keyPath).update(updater);
    },
    map: function map(updater) {
      (0, _Types.default)("map()", "updater", "function")(updater);

      _this.dispatch(_ActionCreators.default.map((0, _prepUpdater.default)(updater)));
    }
  };
};

exports.default = _default;